// LyphLine Freeze Dryers, centralized brand + contact constants.
// Swap these placeholder-friendly values in one place (or later via Admin).

export const BRAND = {
  name: 'LyphLine',
  full: 'LyphLine Freeze Dryers',
  tagline: 'Freeze Dryer Rebuilds & Modifications',
  parent: 'A Peak & Prairie / Chinook Manufacturing company',
};

export const CONTACT = {
  phone: '1-888-223-1435',
  phoneHref: 'tel:+18882231435',
  email: 'service@lyphlinefreezedry.com',
  address: '3164 36th St N, Lethbridge, Alberta, Canada T1H 7E5',
  hours: 'Mon-Fri · 8:00am, 5:00pm MT',
  serviceArea: 'Rebuilds by appointment. Emergency shipping and production scheduling available.',
};

// Cross-links to the sister brands (product lines).
export const PARTNERS = {
  home: { name: 'HomeLyph', url: 'https://homelyph.com', blurb: 'Home & everyday freeze dryers' },
  commercial: { name: 'D-Freeze', url: 'https://d-freeze.ca', blurb: 'Commercial & scientific freeze dryers' },
};

// Freeze Dryer Support — dedicated portal for machine registration & warranty claims.
export const SUPPORT = {
  name: 'Freeze Dryer Support',
  url: 'https://www.freezedryersupport.com',
  blurb: 'Register your machine and submit warranty claims through our dedicated support portal.',
};

// Rebuild / aftermarket-parts disclosure (used site-wide).
export const REBUILD_NOTICE_TITLE = 'Rebuilds, not OEM service.';
export const REBUILD_NOTICE_BODY =
  'LyphLine is an independent rebuilder. In most cases we restore your machine as a full or partial rebuild using quality aftermarket (non OEM) parts, not original manufacturer components, backed by our own 90 day rebuild warranty. This is not an OEM or manufacturer warranty service.';

// Current always-on promotional offer (defaults; can be overridden via Admin Settings).
export const CURRENT_OFFER = {
  active: true,
  headline: '$100 off a full rebuild',
  code: 'REBUILD100',
  detail: "Mention this offer with your request and we'll apply it to your rebuild quote.",
};

// Merge live site settings (from Admin) over the defaults above.
export const getOffer = (settings) => ({
  active: settings?.rebuild_offer_active ?? CURRENT_OFFER.active,
  headline: settings?.rebuild_offer_headline || CURRENT_OFFER.headline,
  code: settings?.rebuild_offer_code || CURRENT_OFFER.code,
  detail: settings?.rebuild_offer_detail || CURRENT_OFFER.detail,
});

// LyphLine palette (distinct industrial ice theme).
export const COLORS = {
  ink: '#003456',
  surface: '#023F63',
  accent: '#CE8946',
  accentHover: '#B87333',
};
